import React from "react";
import {Link} from "react-router-dom";
import styled from "styled-components";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const HeaderContainer=styled.div`
padding:5px 5px;
display:grid;
grid-template-columns:min-content auto min-content;
`;

const StyledLink=styled(Link)`
display:grid;
text-decoration:none;
align-items: center;
`;


const Logo=styled.img`
justify-self:center;
object-fit:contain;
height:50px;
`;

const StyledP=styled.p`
margin:0;
font-size:18px;
justify-self:center;
align-self:center;
text-decoration:none;
`;

const ContainerArrow=styled.div`
align-self: center;
height: min-content;
display: grid;
grid-template-columns: auto auto;
align-items: center;
`;

const ButtonsHeader=styled.button`
background-color:white;
outline:none;
border:none;
cursor:pointer;
height:min-content;
`;

class Header extends React.Component
{
    render()
    {
        return (<HeaderContainer>
          <ContainerArrow onClick={()=> window.history.back()}>
  
            <ButtonsHeader> <ArrowBackIcon style={{display:"inline"}}/></ButtonsHeader>  
            <ButtonsHeader> <StyledP>Volver</StyledP> </ButtonsHeader>
  
          </ContainerArrow>
  
          <div style={{justifySelf: "center"}}>
            <Logo src={"https://firebasestorage.googleapis.com/v0/b/waitwhile-app.appspot.com/o/images%2Faccounts%2F3q2SXkB2XwCwg2a914W9%2F62b4db43-63b9-4629-896f-27dc90d46f77.jpg?alt=media&token=4d305a05-e0da-4658-b42b-2ef93f35d975"} alt="Logo de Baum Lanús"/>
          </div>
  
          <StyledLink to="/lista">
            <ButtonsHeader style={{alignSelf:"center", fontSize:"18px"}}>Cancelar</ButtonsHeader>
          </StyledLink>
      </HeaderContainer>);
    }
}

export default Header;